// P12: the device's IANA timezone travels with its push token, so the API can
// send the 7:00 program push at 7:00 where the user is. Unknown → omitted, and
// the API keeps the timezone it already has (Europe/Paris by default).

/** The device's IANA timezone (e.g. "Europe/Paris"), or null when unknown. */
export function currentTimeZone(intl = globalThis.Intl) {
    try {
        const timeZone = intl?.DateTimeFormat?.().resolvedOptions?.().timeZone
        return typeof timeZone === 'string' && timeZone.trim() !== '' ? timeZone : null
    } catch {
        return null
    }
}

/** The body of POST /device-tokens. */
export function deviceTokenPayload({ token, platform, appVersion, timeZone }) {
    const payload = { token, platform, app_version: appVersion }
    if (timeZone) payload.timezone = timeZone
    return payload
}
